function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { MenuItem, TextField, Tooltip } from 'seagull';
import { RecurrencePeriodTypes } from "../../../models/service/model";
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import { getOccurrenceDisabledData } from "./ServiceBuilder.utils";
const occurrenceOptions = [{
  text: 'One time',
  value: 'onetime'
}, {
  text: 'Weekly',
  value: RecurrencePeriodTypes.Weekly
}, {
  text: 'Biweekly',
  value: RecurrencePeriodTypes.BiWeekly
}, {
  text: 'Monthly',
  value: RecurrencePeriodTypes.Monthly
}, {
  text: 'Quarterly',
  value: RecurrencePeriodTypes.Quarterly
}, {
  text: 'Yearly',
  value: RecurrencePeriodTypes.Yearly
}];
export default function OccurrenceTextField(props) {
  const {
    serviceOrigin,
    service
  } = props;
  const {
    control,
    watch,
    trigger
  } = useFormContext();
  const {
    disabled,
    tooltip
  } = getOccurrenceDisabledData(serviceOrigin, service);
  const [billingTrigger] = watch(['trigger']);
  useEffect(() => {
    trigger('recurrencePeriod');
  }, [billingTrigger]);
  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "recurrencePeriod",
    rules: {
      validate: value => {
        if (billingTrigger === 'ongoing' && value === RecurrencePeriodTypes.Yearly) {
          return "Invalid value";
        }

        return true;
      }
    },
    render: renderProps => /*#__PURE__*/React.createElement(Tooltip, {
      title: tooltip
    }, /*#__PURE__*/React.createElement(TextField, _extends({
      select: true
    }, connectControllerToTextField(renderProps), {
      label: "Billing occurrence",
      "data-testid": "sb-occurrence",
      disabled: disabled
    }), occurrenceOptions.map(_ref => {
      let {
        text,
        value
      } = _ref;
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: value,
        value: value,
        "data-testid": "sb-occurrence-opt-".concat(value)
      }, text);
    })))
  });
}